import React from "react";
import "./index.css";
import HeroSection from "./SECTIONS/HERO";
import StepsSection from "./SECTIONS/STEPS";
import ScreeningSection from "./SECTIONS/SCREENING_PROGRAM";

const ScreeningPage = () => {
  return (
    <>
      {/* <HeroSection /> */}
      <div className="content">
        {/* <StepsSection /> */}
        <ScreeningSection />
      </div>
    </>
  );
};

export default ScreeningPage;
